import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.to}},[_c(VListItem,[_c(VListItemIcon,[_c(VIcon,[_vm._v(_vm._s(_vm.icon))])],1),_c(VListItemTitle,[_vm._v("\n                "+_vm._s(_vm.title)+"\n                ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }